import React from 'react';

export function ConfettiIcon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68.285"
      height="61.062"
      viewBox="0 0 68.285 61.062"
    >
      <g
        id="Group_450"
        data-name="Group 450"
        transform="translate(-286.052 -302.86)"
      >
        <path
          id="Path_2479"
          data-name="Path 2479"
          d="M405.871,329.145a1.714,1.714,0,0,0,2.273-.845c6.428-14.042.159-24.218-.111-24.644a1.715,1.715,0,0,0-2.9,1.829c.228.366,5.517,9.1-.107,21.387A1.715,1.715,0,0,0,405.871,329.145Z"
          transform="translate(-84.861)"
          fill="#f50"
        />
        <path
          id="Path_2480"
          data-name="Path 2480"
          d="M355.09,349.06a1.715,1.715,0,0,0,3.429,0,9.933,9.933,0,0,0-3.16-6.923,1.715,1.715,0,0,0-2.266,2.574A6.514,6.514,0,0,1,355.09,349.06Z"
          transform="translate(-47.474 -27.75)"
          fill="#661aff"
        />
        <path
          id="Path_2481"
          data-name="Path 2481"
          d="M433.689,439.693a1.715,1.715,0,0,0-.141,3.427c.84.037,3.442.41,4.346,1.585a1.715,1.715,0,1,0,2.718-2.091C438.572,439.963,434.183,439.713,433.689,439.693Z"
          transform="translate(-104.172 -97.727)"
          fill="#8446ff"
        />
        <circle
          id="Ellipse_222"
          data-name="Ellipse 222"
          cx="1.448"
          cy="1.448"
          r="1.448"
          transform="translate(299.639 312.861) rotate(-45)"
          fill="#ffca33"
        />
        <circle
          id="Ellipse_223"
          data-name="Ellipse 223"
          cx="1.448"
          cy="1.448"
          r="1.448"
          transform="translate(314.429 314.318) rotate(-9.217)"
          fill="#661aff"
        />
        <circle
          id="Ellipse_224"
          data-name="Ellipse 224"
          cx="1.448"
          cy="1.448"
          r="1.448"
          transform="translate(330.196 309.423) rotate(-13.283)"
          fill="#108000"
        />
        <circle
          id="Ellipse_225"
          data-name="Ellipse 225"
          cx="1.448"
          cy="1.448"
          r="1.448"
          transform="translate(338.661 324.098) rotate(-45)"
          fill="#f50"
        />
        <circle
          id="Ellipse_226"
          data-name="Ellipse 226"
          cx="1.448"
          cy="1.448"
          r="1.448"
          transform="translate(328.829 325.878) rotate(-9.217)"
          fill="#661aff"
        />
        <circle
          id="Ellipse_227"
          data-name="Ellipse 227"
          cx="1.448"
          cy="1.448"
          r="1.448"
          transform="translate(337.169 352.744)"
          fill="#ffca33"
        />
        <circle
          id="Ellipse_228"
          data-name="Ellipse 228"
          cx="1.448"
          cy="1.448"
          r="1.448"
          transform="translate(349.33 342.336) rotate(-13.283)"
          fill="#7e73ff"
        />
        <path
          id="Path_2482"
          data-name="Path 2482"
          d="M353.573,382.907a23.084,23.084,0,0,0-9.917-3.1c-5.124-.5-13,.221-22.249,6.1a54.743,54.743,0,0,0-4.239-4.752c-7.256-7.256-15.11-11.292-18.1-9.428a1.711,1.711,0,0,0-.923,1.037l-.043.135a3.067,3.067,0,0,0-.129.406L286.133,410.55a1.715,1.715,0,0,0,2.179,2.146L324.9,400.443a1.715,1.715,0,0,0,.351-.166,2.514,2.514,0,0,0,1.022-.6c1.744-1.744.483-6.05-2.836-11,6.67-4.207,13.282-6.049,19.693-5.472a20.246,20.246,0,0,1,8.55,2.559,1.715,1.715,0,0,0,1.9-2.857Zm-54.047-3.159a50.116,50.116,0,0,0,19.223,19.138l-28.326,9.486Z"
          transform="translate(0 -48.862)"
          fill="#661aff"
        />
      </g>
    </svg>
  );
}
